export const tituloEspec1 = 'Relacionamento Familiar';
export const tituloEspec2 = 'Relacionamento Amoroso';
export const tituloEspec3 = 'Autoestima e Autoconfiança';
export const tituloEspec4 = 'Transtornos e Gerenciamento de Emoções';
export const tituloEspec5 = 'Ansiedade Emocional';
export const tituloEspec6 = 'Estresse, Depressão e Humor';
export const tituloEspec7 = 'Terapia Personalizada';
export const tituloEspec8 = 'Acolhimento Profissional';
export const tituloEspec9 = 'Apoio Contínuo';
export const tituloEspec10 = 'Facilidade e Flexibilidade';
export const tituloEspec11 = 'Bem-estar Integral';
export const tituloEspec12 = 'Tratamento Comprovado';